
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.33906',
  depVersions: {
  "documents-public-ui": "static-1.33906",
  "client-types": "static-1.444",
  "documents-lib": "static-1.33911",
  "emoji-mart": "static-3.4",
  "foundations-theming-specialty": "static-1.1899",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.4754",
  "highcharts": "static-8.99",
  "hs-promise-utils": "static-1.5365",
  "hs-test-utils": "static-1.7779",
  "hub-http": "static-1.5966",
  "hubspot-dlb": "static-2.1796",
  "HubStyleTokens": "static-2.11195",
  "I18n": "static-7.1562",
  "jasmine-immutable": "static-1.2792",
  "jasmine-runner": "static-1.6246",
  "lodash": "static-1.3",
  "quartz": "static-1.6690",
  "react": "static-7.177",
  "react-dlb": "static-1.71",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-redux": "static-7.66",
  "react-rhumb": "static-1.16415",
  "reporting-data": "static-1.66402",
  "reporting-testing-lib": "static-1.8335",
  "reporting-visualizations": "static-1.58478",
  "tinymce": "static-6.5",
  "ui-addon-draggable": "static-3.4539",
  "webpack-env": "static-1.54",
  "atom": "static-1.4844",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2259",
  "classnames": "static-2.10",
  "cssUtils": "static-1.725",
  "customer-data-filters-ui": "static-1.38789",
  "customer-data-objects": "static-1.7417",
  "customer-data-property-utils": "static-1.7845",
  "data-fetching-client": "static-1.9452",
  "enviro": "static-4.387",
  "FireAlarmUi": "static-1.4303",
  "flux-actions": "static-1.304",
  "FormsCommonComponents": "static-1.85218",
  "FormUrlGenerator": "static-2.4504",
  "foundations-components": "static-1.7474",
  "history": "static-4.47",
  "hs-lodash": "static-4.45",
  "hubspot-url-utils": "static-1.3917",
  "HubStyle": "static-2.11503",
  "icons": "static-2.618",
  "immutable": "static-2.19",
  "isMobile": "static-1.7",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.6936",
  "metrics-js": "static-1.9391",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "PortalIdParser": "static-2.349",
  "property-description-translator": "static-1.3633",
  "property-translator": "static-1.5187",
  "quartz-config": "static-1.468",
  "quartz-core": "static-1.5909",
  "quick-fetch": "static-1.3709",
  "raven": "static-3.5624",
  "react-dom": "static-7.85",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-router-dom": "static-5.26",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5149",
  "react-virtualized": "static-2.94",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.7934",
  "reference-resolvers-lite": "static-1.7864",
  "report-customization-components": "static-1.12438",
  "reporting-enablement": "static-1.21979",
  "reporting-reports": "static-1.66080",
  "reporting-snowflake": "static-1.55020",
  "reporting-ui-components": "static-2.63673",
  "reselect": "static-2.16",
  "rpc-client-utils": "static-1.4406",
  "sales-content-partitioning": "static-1.8709",
  "SalesContentIndexUI": "static-3.8862",
  "sanitize": "static-1.4248",
  "sanitize-text": "static-1.7914",
  "self-service-api": "static-1.10010",
  "SharedI18nStrings": "static-1.180",
  "SharedLegalStrings": "static-1.1528",
  "signup-constants": "static-1.18336",
  "signup-ui-lego-core": "static-1.20346",
  "signup-ui-url-generator": "static-2.7839",
  "styled-components": "static-2.84",
  "StyleGuideUI": "static-3.483",
  "superstore": "static-1.4545",
  "transmute": "static-2.85",
  "ui-addon-form-validation": "static-1.10768",
  "ui-addon-i18n": "static-1.10906",
  "ui-addon-react-router-dom": "static-1.9322",
  "ui-addon-upgrades": "static-9.17613",
  "ui-asset-management-lib": "static-1.10673",
  "ui-images": "static-2.1085",
  "UIComponents": "static-3.8142",
  "usage-tracker": "static-1.7106",
  "usage-tracker-container": "static-1.7096",
  "usage-tracker-core": "static-1.6956",
  "usage-tracker-public": "static-1.6917",
  "viral-links-lib": "static-1.6804",
  "hs-promise-rejection-tracking": "static-1.5291",
  "raven-hubspot": "static-1.5931",
  "hoist-non-react-statics": "static-3.9",
  "bend-plugin-trellis-migration": "static-1.3203",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.2967",
  "quartz-webpack": "static-1.2914",
  "ai-components-ui-library": "static-1.8278",
  "amplitude-session-replay-browser": "static-1.55",
  "foundations-assets": "static-1.4607",
  "foundations-theming": "static-1.4183",
  "quartz-auth": "static-1.365",
  "usage-tracker-session-replay": "static-1.4792",
  "foundations-theming-base": "static-1.3168",
  "HeadJS": "static-2.704",
  "framer-motion": "static-1.67",
  "hs-test-utils-bend-plugin": "static-1.2890",
  "msw": "static-1.39",
  "testing-library": "static-1.147",
  "i18n-data": "static-1.216",
  "moment-timezone": "static-5.78",
  "jasmine": "static-4.4103",
  "csstype": "static-1.50",
  "frontend-preferences-client": "static-1.7698",
  "graphql": "static-1.77",
  "immer": "static-1.33",
  "inbound-db-meta-service-client": "static-1.3397",
  "persist-promise": "static-1.3481",
  "reporting-client-types": "static-1.2379",
  "hs-story-utils": "static-1.9202",
  "react-flip-move": "static-1.65",
  "hub-http-shared-msw-handlers": "static-1.9414",
  "hubspotter-http": "static-1.4453",
  "sassPrefix": "static-1.151",
  "conversations-skeleton-state": "static-1.7023",
  "crm-message-bus": "static-1.42271",
  "customer-data-filters-ui-msw-helpers": "static-1.21223",
  "customer-data-objects-ui-components": "static-1.12778",
  "customer-data-reference-ui-components": "static-1.12915",
  "customer-data-ui-utilities": "static-1.9597",
  "framework-builder-read-service-client": "static-1.3817",
  "framework-data-schema-quick-fetch": "static-1.6549",
  "framework-data-schema-resolvers": "static-1.6644",
  "inbound-db-properties-service-client": "static-1.3651",
  "multi-account-reference-resolvers": "static-1.743",
  "onboarding-tours": "static-1.16221",
  "reporting-datasets-permissions-lib": "static-1.12976",
  "ui-addon-teams": "static-1.21204",
  "apollo-stack-hubspot": "static-3.81",
  "fast-json-stable-stringify": "static-1.4",
  "ContentUtils": "static-1.67547",
  "customer-data-properties": "static-1.50716",
  "forms-ai-lib": "static-1.3974",
  "forms-utils-lib": "static-1.12120",
  "foundations-components-test-utils": "static-1.4957",
  "react-dnd-compat": "static-1.4396",
  "react-tinymce": "static-1.54547",
  "tinymce-config": "static-2.53673",
  "ui-gdpr-components": "static-1.10121",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.3743",
  "floating-ui": "static-1.51",
  "react-aria": "static-1.61",
  "tanstack-table": "static-1.50",
  "trellis-assets": "static-1.1120",
  "ui-fonts": "static-1.457",
  "dispatcher": "static-1.131",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.787",
  "mobile-manifest-mixins": "static-1.477",
  "module-federation": "static-1.18",
  "quartz-head": "static-1.355",
  "quartz-i18n": "static-1.365",
  "quartz-routing": "static-1.120",
  "quartz-test": "static-1.365",
  "batch-promise": "static-1.1324",
  "external-options-client-types": "static-1.3960",
  "react-colorpicker": "static-2.9985",
  "copilot-toolkit": "static-1.10454",
  "data-quality-ui-library": "static-1.12259",
  "html-to-image": "static-1.49",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.40590",
  "reporting-insights-lib": "static-1.1081",
  "reporting-plugins": "static-1.9948",
  "ui-addon-draggable-compat": "static-2.4027",
  "ui-addon-opt": "static-4.8159",
  "ui-shepherd-react": "static-3.9918",
  "zustand": "static-1.51",
  "growth-payments-core": "static-1.24648",
  "hubspot-apollo-client": "static-1.4653",
  "sales-templates-service-types-lib": "static-1.3970",
  "ui-business-units-lib": "static-1.8798",
  "merchandise-lib": "static-1.258",
  "emoji-regex": "static-1.7",
  "purchase-motions-components": "static-1.5447",
  "salesImages": "static-1.520",
  "ts-schema": "static-1.3880",
  "upgrade-management-service-types": "static-1.4282",
  "timezone-utils": "static-2.5018",
  "bender-build-tools": "static-1.2912",
  "chatspot-core": "static-1.20204",
  "chirp-fetch": "static-1.1658",
  "bend-plugin-foundations-theming": "static-1.2666",
  "stylex": "static-1.27",
  "hubspotter-http-shared-msw-handlers": "static-1.9412",
  "react-immutable-render-mixin": "static-1.9",
  "conditional-properties-service-client": "static-1.3600",
  "crm-pipelines-api-client-types": "static-1.3940",
  "multi-currency-client-types": "static-1.3494",
  "getting-started-shared-tasks": "static-1.17804",
  "growth-data-modal": "static-1.5125",
  "growth-onboarding-confetti": "static-1.2844",
  "growth-onboarding-next-action-utils": "static-1.1269",
  "navigation-components": "static-1.17183",
  "onboarding-tours-client": "static-1.4435",
  "onboarding-tours-utils": "static-1.287",
  "ui-shepherd-tracker": "static-1.7299",
  "ui-universal-auth": "static-1.8654",
  "user-context": "static-1.4868",
  "cms-field-types": "static-1.4579",
  "content-icons-ui": "static-1.2146",
  "integrations-lib": "static-1.15330",
  "calling-global-api": "static-1.63561",
  "calling-internal-common": "static-1.31067",
  "calling-lifecycle-internal": "static-1.64943",
  "calling-lifecycle-messages": "static-1.57237",
  "commerce-products-lib": "static-1.8775",
  "crm-links": "static-1.6029",
  "file-manager-components": "static-1.22811",
  "google-libphonenumber": "static-1.33",
  "hs-entities": "static-1.447",
  "inbounddb-objects-service-types": "static-1.4026",
  "meetings-icalendar-utils-lib": "static-1.407",
  "object-builder-ui-client": "static-1.47878",
  "pipeline-validation-client-types": "static-1.3762",
  "property-value-citations": "static-1.1330",
  "pulse": "static-1.279",
  "smart-property-lib": "static-1.5776",
  "tiered-pricing": "static-1.788",
  "ui-addon-iframeable": "static-1.8815",
  "final-form": "static-1.65",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.19428",
  "tinymce-themes": "static-1.55643",
  "data-token-picker": "static-1.16000",
  "hub-http-contrib": "static-1.2818",
  "interframe": "static-3.4565",
  "tinymce-data": "static-1.39758",
  "tinymce-plugins": "static-1.56787",
  "ui-addon-sales-email": "static-1.4987",
  "magpie-lib": "static-1.5368",
  "magpie-types": "static-1.4828",
  "simple-logging-lib": "static-1.2824",
  "content-assistance-lib": "static-1.7411",
  "dashboard-lib": "static-1.80521",
  "ExportDialog": "static-6.10162",
  "hubspot-prosemirror": "static-1.17531",
  "hubspot-prosemirror-plugins": "static-1.17523",
  "prosemirror": "static-1.13",
  "share-with-third-party-component-lib": "static-1.8465",
  "campaign-roi-lib": "static-1.8186",
  "feedback-loader": "static-1.28804",
  "onboarding-scopes": "static-1.6237",
  "apollo-link-hub-http": "static-2.4422",
  "hubspot-apollo-cache": "static-1.112",
  "growth-monetization-service-types": "static-1.4298",
  "nav-client-types": "static-1.2130",
  "purchase-motions-api": "static-1.5450",
  "trials-service-types": "static-1.3699",
  "idb-keyval": "static-1.39",
  "reactive-lib": "static-1.500",
  "unified-auth-core-lib": "static-1.449",
  "getting-started-shared-tasks-store": "static-1.16922",
  "integrations-error-boundary-lib": "static-1.12745",
  "integrations-tracking-lib": "static-1.5358",
  "native-integrations-shared-strings": "static-1.7562",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10146",
  "rxjs": "static-5.10",
  "calling-error-reporting": "static-1.31073",
  "shared-worker-versioning": "static-1.10810",
  "calling-usage-tracker": "static-1.6312",
  "voice-sms-access-library": "static-1.163",
  "customer-data-tracking": "static-1.6655",
  "products-iframe-lib": "static-1.7243",
  "products-ui-components-shared-msw-handlers": "static-1.9796",
  "location-customization-utils-lib": "static-1.8470",
  "apollo-dlb": "static-3.80",
  "immerable": "static-1.3928",
  "video-components-external": "static-1.10488",
  "video-data-lib": "static-1.34146",
  "directed-graph": "static-1.711",
  "event-emitter": "static-1.721",
  "breeze-intelligence-kit": "static-1.5283",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9497",
  "fsm": "static-1.3505",
  "policy-lib": "static-1.6554",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9560",
  "navigation-messaging": "static-1.6510",
  "FileManagerLib": "static-1.38451",
  "NamespacedHubStyle": "static-2.8872",
  "FileManagerCore": "static-1.38310",
  "codemirror": "static-5.90",
  "layout-dnd-components": "static-1.11984",
  "layout-dnd-utils": "static-1.10959",
  "react-codemirror": "static-1.10400",
  "ui-addon-emoji-picker": "static-1.9662",
  "ui-brand-identity-lib": "static-1.13738",
  "ui-addon-video-player": "static-1.8470",
  "ui-coaching-tips": "static-1.27873",
  "redux-actions": "static-3.7",
  "knowledge-content-types": "static-1.8343",
  "payment-link-components": "static-1.22866",
  "EmailSignatureEditor": "static-1.23859",
  "eligibility-engine-service-types": "static-1.2980",
  "universal-page-editor-lib": "static-1.2770",
  "calling-orchestration-schema": "static-1.34940",
  "sales-views-client-types": "static-1.4066",
  "crm-record-cards-service-types": "static-1.3428",
  "content-media-composition-data-lib": "static-1.11352",
  "content-media-compositions": "static-2.15359",
  "media-bridge-lib": "static-1.18522",
  "trellis-story-utils": "static-1.4297",
  "storybook-react": "static-1.28",
  "audio-components": "static-1.5575",
  "FileManagerImages": "static-1.35962",
  "video-components": "static-1.12491",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4308",
  "video-embed": "static-1.34980",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.67622",
  "layout-data-lib": "static-1.9284",
  "browser-eslint": "static-2.57",
  "growth-onboarding-feedback-components": "static-1.6359",
  "commerce-tours-lib": "static-1.5677",
  "growth-onboarding-reliability": "static-1.4862",
  "sales-checkout-service-client": "static-1.3452",
  "draft-convert": "static-2.67",
  "draft-extend": "static-3.70",
  "draft-js": "static-5.72",
  "draft-plugins": "static-2.21266",
  "sales-email-signature-service-client": "static-1.3619",
  "hls.js": "static-1.34",
  "social-insights-client-types": "static-1.21265",
  "outpost": "static-1.3979",
  "advanced-menus-core": "static-1.14777",
  "advanced-menus-lib": "static-1.11757",
  "ui-memberships-settings-lib": "static-1.33357",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14776",
  "simple-menus-lib": "static-1.16293"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.33906",
  "client-types": "/client-types/static-1.444",
  "documents-lib": "/documents-lib/static-1.33911",
  "emoji-mart": "/emoji-mart/static-3.4",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1899",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.4754",
  "highcharts": "/highcharts/static-8.99",
  "hs-promise-utils": "/hs-promise-utils/static-1.5365",
  "hs-test-utils": "/hs-test-utils/static-1.7779",
  "hub-http": "/hub-http/static-1.5966",
  "hubspot-dlb": "/hubspot-dlb/static-2.1796",
  "HubStyleTokens": "/HubStyleTokens/static-2.11195",
  "I18n": "/I18n/static-7.1562",
  "jasmine-immutable": "/jasmine-immutable/static-1.2792",
  "jasmine-runner": "/jasmine-runner/static-1.6246",
  "lodash": "/lodash/static-1.3",
  "quartz": "/quartz/static-1.6690",
  "react": "/react/static-7.177",
  "react-dlb": "/react-dlb/static-1.71",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-redux": "/react-redux/static-7.66",
  "react-rhumb": "/react-rhumb/static-1.16415",
  "reporting-data": "/reporting-data/static-1.66402",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.8335",
  "reporting-visualizations": "/reporting-visualizations/static-1.58478",
  "tinymce": "/tinymce/static-6.5",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4539",
  "webpack-env": "/webpack-env/static-1.54",
  "atom": "/atom/static-1.4844",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2259",
  "classnames": "/classnames/static-2.10",
  "cssUtils": "/cssUtils/static-1.725",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.38789",
  "customer-data-objects": "/customer-data-objects/static-1.7417",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7845",
  "data-fetching-client": "/data-fetching-client/static-1.9452",
  "enviro": "/enviro/static-4.387",
  "FireAlarmUi": "/FireAlarmUi/static-1.4303",
  "flux-actions": "/flux-actions/static-1.304",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85218",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4504",
  "foundations-components": "/foundations-components/static-1.7474",
  "history": "/history/static-4.47",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3917",
  "HubStyle": "/HubStyle/static-2.11503",
  "icons": "/icons/static-2.618",
  "immutable": "/immutable/static-2.19",
  "isMobile": "/isMobile/static-1.7",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.6936",
  "metrics-js": "/metrics-js/static-1.9391",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "PortalIdParser": "/PortalIdParser/static-2.349",
  "property-description-translator": "/property-description-translator/static-1.3633",
  "property-translator": "/property-translator/static-1.5187",
  "quartz-config": "/quartz-config/static-1.468",
  "quartz-core": "/quartz-core/static-1.5909",
  "quick-fetch": "/quick-fetch/static-1.3709",
  "raven": "/raven/static-3.5624",
  "react-dom": "/react-dom/static-7.85",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-router-dom": "/react-router-dom/static-5.26",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5149",
  "react-virtualized": "/react-virtualized/static-2.94",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.7934",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7864",
  "report-customization-components": "/report-customization-components/static-1.12438",
  "reporting-enablement": "/reporting-enablement/static-1.21979",
  "reporting-reports": "/reporting-reports/static-1.66080",
  "reporting-snowflake": "/reporting-snowflake/static-1.55020",
  "reporting-ui-components": "/reporting-ui-components/static-2.63673",
  "reselect": "/reselect/static-2.16",
  "rpc-client-utils": "/rpc-client-utils/static-1.4406",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.8709",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8862",
  "sanitize": "/sanitize/static-1.4248",
  "sanitize-text": "/sanitize-text/static-1.7914",
  "self-service-api": "/self-service-api/static-1.10010",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.180",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1528",
  "signup-constants": "/signup-constants/static-1.18336",
  "signup-ui-lego-core": "/signup-ui-lego-core/static-1.20346",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7839",
  "styled-components": "/styled-components/static-2.84",
  "StyleGuideUI": "/StyleGuideUI/static-3.483",
  "superstore": "/superstore/static-1.4545",
  "transmute": "/transmute/static-2.85",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10768",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10906",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9322",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17613",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10673",
  "ui-images": "/ui-images/static-2.1085",
  "UIComponents": "/UIComponents/static-3.8142",
  "usage-tracker": "/usage-tracker/static-1.7106",
  "usage-tracker-container": "/usage-tracker-container/static-1.7096",
  "usage-tracker-core": "/usage-tracker-core/static-1.6956",
  "usage-tracker-public": "/usage-tracker-public/static-1.6917",
  "viral-links-lib": "/viral-links-lib/static-1.6804",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5291",
  "raven-hubspot": "/raven-hubspot/static-1.5931",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3203",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.2967",
  "quartz-webpack": "/quartz-webpack/static-1.2914",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8278",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.55",
  "foundations-assets": "/foundations-assets/static-1.4607",
  "foundations-theming": "/foundations-theming/static-1.4183",
  "quartz-auth": "/quartz-auth/static-1.365",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4792",
  "foundations-theming-base": "/foundations-theming-base/static-1.3168",
  "HeadJS": "/HeadJS/static-2.704",
  "framer-motion": "/framer-motion/static-1.67",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2890",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.147",
  "i18n-data": "/i18n-data/static-1.216",
  "moment-timezone": "/moment-timezone/static-5.78",
  "jasmine": "/jasmine/static-4.4103",
  "csstype": "/csstype/static-1.50",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7698",
  "graphql": "/graphql/static-1.77",
  "immer": "/immer/static-1.33",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3397",
  "persist-promise": "/persist-promise/static-1.3481",
  "reporting-client-types": "/reporting-client-types/static-1.2379",
  "hs-story-utils": "/hs-story-utils/static-1.9202",
  "react-flip-move": "/react-flip-move/static-1.65",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9414",
  "hubspotter-http": "/hubspotter-http/static-1.4453",
  "sassPrefix": "/sassPrefix/static-1.151",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7023",
  "crm-message-bus": "/crm-message-bus/static-1.42271",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21223",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12778",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12915",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9597",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3817",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6549",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6644",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3651",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.743",
  "onboarding-tours": "/onboarding-tours/static-1.16221",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.12976",
  "ui-addon-teams": "/ui-addon-teams/static-1.21204",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.81",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "ContentUtils": "/ContentUtils/static-1.67547",
  "customer-data-properties": "/customer-data-properties/static-1.50716",
  "forms-ai-lib": "/forms-ai-lib/static-1.3974",
  "forms-utils-lib": "/forms-utils-lib/static-1.12120",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.4957",
  "react-dnd-compat": "/react-dnd-compat/static-1.4396",
  "react-tinymce": "/react-tinymce/static-1.54547",
  "tinymce-config": "/tinymce-config/static-2.53673",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10121",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3743",
  "floating-ui": "/floating-ui/static-1.51",
  "react-aria": "/react-aria/static-1.61",
  "tanstack-table": "/tanstack-table/static-1.50",
  "trellis-assets": "/trellis-assets/static-1.1120",
  "ui-fonts": "/ui-fonts/static-1.457",
  "dispatcher": "/dispatcher/static-1.131",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.787",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.477",
  "module-federation": "/module-federation/static-1.18",
  "quartz-head": "/quartz-head/static-1.355",
  "quartz-i18n": "/quartz-i18n/static-1.365",
  "quartz-routing": "/quartz-routing/static-1.120",
  "quartz-test": "/quartz-test/static-1.365",
  "batch-promise": "/batch-promise/static-1.1324",
  "external-options-client-types": "/external-options-client-types/static-1.3960",
  "react-colorpicker": "/react-colorpicker/static-2.9985",
  "copilot-toolkit": "/copilot-toolkit/static-1.10454",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12259",
  "html-to-image": "/html-to-image/static-1.49",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.40590",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.1081",
  "reporting-plugins": "/reporting-plugins/static-1.9948",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4027",
  "ui-addon-opt": "/ui-addon-opt/static-4.8159",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.9918",
  "zustand": "/zustand/static-1.51",
  "growth-payments-core": "/growth-payments-core/static-1.24648",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4653",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.3970",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8798",
  "merchandise-lib": "/merchandise-lib/static-1.258",
  "emoji-regex": "/emoji-regex/static-1.7",
  "purchase-motions-components": "/purchase-motions-components/static-1.5447",
  "salesImages": "/salesImages/static-1.520",
  "ts-schema": "/ts-schema/static-1.3880",
  "upgrade-management-service-types": "/upgrade-management-service-types/static-1.4282",
  "timezone-utils": "/timezone-utils/static-2.5018",
  "bender-build-tools": "/bender-build-tools/static-1.2912",
  "chatspot-core": "/chatspot-core/static-1.20204",
  "chirp-fetch": "/chirp-fetch/static-1.1658",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2666",
  "stylex": "/stylex/static-1.27",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9412",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3600",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3940",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3494",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17804",
  "growth-data-modal": "/growth-data-modal/static-1.5125",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2844",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1269",
  "navigation-components": "/navigation-components/static-1.17183",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4435",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.287",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7299",
  "ui-universal-auth": "/ui-universal-auth/static-1.8654",
  "user-context": "/user-context/static-1.4868",
  "cms-field-types": "/cms-field-types/static-1.4579",
  "content-icons-ui": "/content-icons-ui/static-1.2146",
  "integrations-lib": "/integrations-lib/static-1.15330",
  "calling-global-api": "/calling-global-api/static-1.63561",
  "calling-internal-common": "/calling-internal-common/static-1.31067",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.64943",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57237",
  "commerce-products-lib": "/commerce-products-lib/static-1.8775",
  "crm-links": "/crm-links/static-1.6029",
  "file-manager-components": "/file-manager-components/static-1.22811",
  "google-libphonenumber": "/google-libphonenumber/static-1.33",
  "hs-entities": "/hs-entities/static-1.447",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4026",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.407",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.47878",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3762",
  "property-value-citations": "/property-value-citations/static-1.1330",
  "pulse": "/pulse/static-1.279",
  "smart-property-lib": "/smart-property-lib/static-1.5776",
  "tiered-pricing": "/tiered-pricing/static-1.788",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8815",
  "final-form": "/final-form/static-1.65",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.19428",
  "tinymce-themes": "/tinymce-themes/static-1.55643",
  "data-token-picker": "/data-token-picker/static-1.16000",
  "hub-http-contrib": "/hub-http-contrib/static-1.2818",
  "interframe": "/interframe/static-3.4565",
  "tinymce-data": "/tinymce-data/static-1.39758",
  "tinymce-plugins": "/tinymce-plugins/static-1.56787",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.4987",
  "magpie-lib": "/magpie-lib/static-1.5368",
  "magpie-types": "/magpie-types/static-1.4828",
  "simple-logging-lib": "/simple-logging-lib/static-1.2824",
  "content-assistance-lib": "/content-assistance-lib/static-1.7411",
  "dashboard-lib": "/dashboard-lib/static-1.80521",
  "ExportDialog": "/ExportDialog/static-6.10162",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17531",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17523",
  "prosemirror": "/prosemirror/static-1.13",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8465",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8186",
  "feedback-loader": "/feedback-loader/static-1.28804",
  "onboarding-scopes": "/onboarding-scopes/static-1.6237",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4422",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.112",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4298",
  "nav-client-types": "/nav-client-types/static-1.2130",
  "purchase-motions-api": "/purchase-motions-api/static-1.5450",
  "trials-service-types": "/trials-service-types/static-1.3699",
  "idb-keyval": "/idb-keyval/static-1.39",
  "reactive-lib": "/reactive-lib/static-1.500",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.449",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.16922",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12745",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5358",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7562",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10146",
  "rxjs": "/rxjs/static-5.10",
  "calling-error-reporting": "/calling-error-reporting/static-1.31073",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10810",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6312",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.163",
  "customer-data-tracking": "/customer-data-tracking/static-1.6655",
  "products-iframe-lib": "/products-iframe-lib/static-1.7243",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9796",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8470",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "immerable": "/immerable/static-1.3928",
  "video-components-external": "/video-components-external/static-1.10488",
  "video-data-lib": "/video-data-lib/static-1.34146",
  "directed-graph": "/directed-graph/static-1.711",
  "event-emitter": "/event-emitter/static-1.721",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5283",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9497",
  "fsm": "/fsm/static-1.3505",
  "policy-lib": "/policy-lib/static-1.6554",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9560",
  "navigation-messaging": "/navigation-messaging/static-1.6510",
  "FileManagerLib": "/FileManagerLib/static-1.38451",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8872",
  "FileManagerCore": "/FileManagerCore/static-1.38310",
  "codemirror": "/codemirror/static-5.90",
  "layout-dnd-components": "/layout-dnd-components/static-1.11984",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.10959",
  "react-codemirror": "/react-codemirror/static-1.10400",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9662",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.13738",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8470",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.27873",
  "redux-actions": "/redux-actions/static-3.7",
  "knowledge-content-types": "/knowledge-content-types/static-1.8343",
  "payment-link-components": "/payment-link-components/static-1.22866",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23859",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.2980",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2770",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.34940",
  "sales-views-client-types": "/sales-views-client-types/static-1.4066",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3428",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11352",
  "content-media-compositions": "/content-media-compositions/static-2.15359",
  "media-bridge-lib": "/media-bridge-lib/static-1.18522",
  "trellis-story-utils": "/trellis-story-utils/static-1.4297",
  "storybook-react": "/storybook-react/static-1.28",
  "audio-components": "/audio-components/static-1.5575",
  "FileManagerImages": "/FileManagerImages/static-1.35962",
  "video-components": "/video-components/static-1.12491",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4308",
  "video-embed": "/video-embed/static-1.34980",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.67622",
  "layout-data-lib": "/layout-data-lib/static-1.9284",
  "browser-eslint": "/browser-eslint/static-2.57",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6359",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5677",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4862",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3452",
  "draft-convert": "/draft-convert/static-2.67",
  "draft-extend": "/draft-extend/static-3.70",
  "draft-js": "/draft-js/static-5.72",
  "draft-plugins": "/draft-plugins/static-2.21266",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3619",
  "hls.js": "/hls.js/static-1.34",
  "social-insights-client-types": "/social-insights-client-types/static-1.21265",
  "outpost": "/outpost/static-1.3979",
  "advanced-menus-core": "/advanced-menus-core/static-1.14777",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11757",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33357",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14776",
  "simple-menus-lib": "/simple-menus-lib/static-1.16293"
}
};
